import React from "react";
import "../styles/TermsAndConditions.css";

const TermsAndConditions = () => {
  return (
    <div className="section terms-container">
      <h1 className="heading-secondary">Termeni și Condiții</h1>
      <p className="terms-paragraph">
        Comanda dumneavoastră prin www.gardeniaflowers.md sau prin telefon
        reprezintă acceptarea implicită a următoarelor condiții:
      </p>

      <h2 className="terms-subheader">Drepturi de autor</h2>
      <p className="terms-paragraph">
        Toate imaginile prezentate pe www.gardeniaflowers.md sunt proprietate a
        companiei FLORELITE DESING SRL. Preluarea lor fără acordul nostru în
        scris este ilegală și va fi semnalată ca atare.
      </p>

      <h2 className="terms-subheader">Metode de Plata</h2>
      <p className="terms-paragraph">
        În magazinul nostru online, puteți alege compozitia de flori care sa
        transmita emotiile si afectiunea pentru o persoana draga din viata dvs.
        Chiar si atunci cind alegeti sa manifestati un simplu gest de multumire
        sau recunostinta, noi la fel va punem la dispozitie diferite
        interpretari florare pentru a o face.
      </p>
      <p className="terms-paragraph">
        Va punem la dispozitie urmatoarele optiuni pentru a efectua plata pentru
        comanda dvs.:
      </p>
      <ul className="payment-methods">
        <li className="payment-method">
          <strong>1. Credit card/Debit card:</strong> Poti plati fara griji cu
          cardul tau de credit sau de debit. Tranzactiile sunt securizate si
          procesate de catre PayNet. Vă asigurăm că nu stocăm niciuna dintre
          datele de card folosite în plățile online către Gardenia Flowers.
        </li>
        <li className="payment-method">
          <strong>2. Cash la livrare:</strong> Doriți să plătiți cu bani cash?
          Nicio problemă. Noi vă aducem florile pe care vi le doriți, iar
          dumneavoastră puteți înmâna suma datorată curierului nostru.
        </li>
        <li className="payment-method">
          <strong>3. Plata la sediul Gardenia FLowers:</strong> Puteți achita
          comanda direct la noi – cash sau cu cardul.
        </li>
      </ul>

      <h2 className="terms-subheader">
        Politica de refuz/acceptare a comenzii
      </h2>
      <p className="terms-paragraph">
        Pot apărea cazuti si circumstante imprevizibile, în care suntem pusi in
        situatia de a refuza o anumita comanda. În aceste situații se va
        rambursa plata respectivei comenzi. Prețurile afișate pe site includ
        TVA.
      </p>

      <h2 className="terms-subheader">
        Anularea sau schimbarea comenzii de catre client
      </h2>
      <p className="terms-paragraph">
        Dacă o comandă a fost deja transmisă spre pregatire atunci ea nu mai
        poate fi anulată! Încercăm să gestionam in timp util solicitarile
        parvenite din partea clientilor, dar acest lucru este posibil de
        realizat nu mai tirziu decit cu 24 ore inainte de livrarea propriu-zisa.
      </p>

      <h2 className="terms-subheader">
        Rezolvarea problemelor legate de plata
      </h2>
      <p className="terms-paragraph">
        Decizia de a cumpăra flori online pe www.gardeniaflowers.md este una
        sigură având în vedere că tranzacțiile pe pagina noastră sunt asigurate
        prin PayNet. Se poate întâmpla însă uneori să existe erori în tranzacția
        bancară care să întârzie acceptarea comenzii de către noi. În cazul unui
        mesaj din partea băncii sau din partea noastră legat de plată vă rugăm
        să ne contactați la numărul afișat pe site.
      </p>

      <h2 className="terms-subheader">
        Aranjamente florale si disponibilitatea lor in functie de anotimp
      </h2>
      <p className="terms-paragraph">
        În cazul în care nu există în stoc sau calitatea florilor primite de la
        furnizorii noștri nu este la standardele cerute de noi, ne rezervăm
        dreptul de a schimba respectivul sortiment cu unul echivalent ca stil și
        de aceeași valoare sau mai mare.
      </p>

      <h2 className="terms-subheader">Garantii oferite de noi</h2>
      <p className="terms-paragraph">
        Pentru produsele și serviciile care se află sub controlul nostru vă
        oferim garanția rambursării totale a plății sau oferirea unor vouchere
        cadou în contravaloare dacă:
      </p>
      <ul className="guarantees-list">
        <li>Livrarea a întârziat la data agreată.</li>
        <li>
          Nu putem să onorăm comanda dumneavoastră din motive ce țin de noi, vă
          vom returna banii.
        </li>
        <li>
          A fost livrat produsul greșit. O să vă rugăm să ne semnalați greșeala,
          iar noi vom retrimite comanda dumneavoastră.
        </li>
      </ul>
      <p className="terms-paragraph">
        Suntem la legatura cu clientii nostri 24/7, astfel oferind un serviciu
        de asistenta rapid si eficient pentru orice problema legata de comanda.
      </p>

      <h2 className="terms-subheader">Livrări în țară</h2>
      <p className="terms-paragraph">
        Pentru livrări pe teriotoriul Republicii Moldova, Gardenia Flowers
        lucrează în parteneriat cu colaboratori externi pentru serviciul de
        livrare. Plasarea comenzilor pentru livrarea buchetelor sau
        aranjamentelo in afara mun. Chisinau trebuie efectuata cu cel putin 24
        ore inainte.
      </p>

      <h2 className="terms-subheader">
        Folosirea datelor personale folosite în comunicarea cu
        www.gardeniaflowers.md
      </h2>
      <p className="terms-paragraph">
        Sunt situații în care este extrem de important să luăm legătura cu
        dumneavoastră pentru a vă oferi comanda dorită. De aceea vă rugăm ca
        datele oferite în crearea contului personal să fie actuale și corecte.
      </p>
      <p className="terms-paragraph">
        Prețuim discreția și încrederea acordată și vă asigurăm că nu închiriem
        sau vindem bazele noastre de date! Pentru mai multe detalii vă invităm
        să consultați politica noastră de securitate a datelor.
      </p>
      <h2 className="terms-subheader">Date de contact</h2>
      <p className="terms-paragraph">
        Denumirea juridică a companiei: FLORELITE DESIGN SRL
        <p>IDNO: 1022600015904</p>
        <p>Adresa juridică: mun. Chișinău, Str. Nicolae Costin 65/3, 17 </p>
        <p>Adresa fizică: mun. Chișinău, Str. Petru Rares 37</p>
        <p>Telefon de contact: +373 78 774 774</p>
        <p>Email: order@gardeniaflowers.info</p>
      </p>
    </div>
  );
};

export default TermsAndConditions;
